import { render, staticRenderFns } from "./OrderDeliveryInventory.vue?vue&type=template&id=d2648c64&"
import script from "./OrderDeliveryInventory.vue?vue&type=script&lang=ts&"
export * from "./OrderDeliveryInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports